module.exports = __webpack_public_path__ + "img/erweima.73d7a8d1.png";